import React from "react";
import { Droppable, Draggable } from "react-beautiful-dnd";
import KanbanCard from "../../../../../components/Kanban/KanbanCard";
import CreateCard from "../CreateCard";

const MobileTodo = ({ projects, droppableId, stage,isCreateCardFieldOpen,handleCreateCardClick,isMobile=false, boardName }) => {
  return (
    <Droppable droppableId={droppableId}>
      {(provided) => (
        <div
          className="mobile-kanban-column"
          ref={provided.innerRef}
          {...provided.droppableProps}
        >
          <CreateCard
            isCreateCardFieldOpen={isCreateCardFieldOpen}
            handleCreateCardClick={handleCreateCardClick}
            stage={stage}
            boardName={boardName}
          />
          {projects.map((project, index) => (
            <Draggable
              key={project?.card?.card_id}
              draggableId={project?.card?.card_id.toString()}
              index={index}
              isDragDisabled={isMobile}
            >
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                  className="mobile-kanban-card"
                  style={{
                    ...provided.draggableProps.style,
                    opacity: snapshot.isDragging ? 0.8 : 1,
                  }}
                >
                  <KanbanCard
                    id={project?.card?.card_id}
                    project={project}
                    index={index}
                    stage={droppableId}
                  />
                </div>
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

export default MobileTodo;
